import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-postgresql-checklist',
  templateUrl: './help-postgresql-checklist.component.html',
  styleUrls: ['./help-postgresql-checklist.component.scss']
})
export class HelpPostgresqlChecklistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
